function StreamsController(stateService, userService, $state) {
  const ctrl = this;

  ctrl.$onInit = () => {
    let selectedWorkspace = stateService.getSelectedWorkspace();
    ctrl.workspaceId = selectedWorkspace.id;
    ctrl.isLocked = selectedWorkspace.deployable;
    if (!ctrl.workspaceId) $state.go('pis.workspaces');
    ctrl.editMode = false;
    loadStreams();
    ctrl.modalOptions = {
      name: 'stream',
      fields: [
        { name: 'Name', key: 'name', type: 'row' },
        { name: 'Description', key: 'description', type: 'row' },
        { name: 'Types', key: 'types', type: 'list', listKey: 'name' },
        { name: 'Fragments', key: 'fragments', type: 'list', listKey: 'text' },
      ],
      deleteCheck: true,
    };
    ctrl.hasCommit = userService.hasCommitPIS();
    ctrl.hasEdit = userService.hasEditPIS();
  };

  const loadStreams = () => {
    stateService.getStreams(ctrl.workspaceId).then(data => {
      ctrl.streams = data;
      checkIfInUse(ctrl.streams);
    });
  };

  const checkIfInUse = streams => {
    streams.map(stream => {
      if (stream.conditions.length > 0 || stream.triggers.length > 0) {
        stream.deletable = false;
      } else {
        stream.deletable = true;
      }
    });
  };

  ctrl.onToggleEdit = event => {
    ctrl.editMode = event.editMode;
    ctrl.selection = event.item;
  };

  ctrl.onDelete = event => {
    stateService.deleteStream(ctrl.workspaceId, event.itemId).then(
      response => {
        loadStreams();
        ctrl.selection = null;
        // toasterService.success('toaster.package-upload-event', 'toaster.package-upload-start-success');
      },
      function(e) {
        // toasterService.error('toaster.package-upload-event', 'toaster.package-upload-start-failure');
        console.log(e);
      }
    );
  };

  ctrl.onFormSubmit = event => {
    ctrl.editMode = event.mode;
    loadStreams();
    ctrl.selection = null;
  };

  ctrl.setEditMode = () => {
    ctrl.editMode = true;
  };

  ctrl.goBackToList = () => {
    ctrl.editMode = false;
    loadStreams();
    ctrl.selection = null;
  };
}

angular
  .module('pis-tool.module')
  .controller('StreamsController', StreamsController);
